import React from "react";

function Logo(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 80 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Logo"
        d="M0.336914 59.311L13.9721 33.309L34.2331 38.4477L45.7011 16.1687L65.27 20.5876L79.7202 0.456173L79.7202 59.311L0.336914 59.311Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Logo;
